import { useCallback, useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getShippers as getShippersUseCase } from '../use-cases/getShippers'

type ShippersParams = {
  limit?: number
  offset?: number
  search?: string
}

export function useShippers(params: ShippersParams = {}) {
  const { limit = 10, offset = 0, search } = params
  const abortController = useAbortController([limit, offset, search])

  const fetchShippersFn = useCallback(
    () => getShippersUseCase({ limit, offset, search }, abortController),
    [limit, offset, search, abortController]
  )

  const { call: fetchShippers, result, error, status } = useAsync(fetchShippersFn)

  useEffect(() => {
    fetchShippers()
  }, [fetchShippers])

  return {
    fetchShippers,
    shippers: result?.shippers ?? [],
    totalCount: result?.totalCount ?? 0,
    status,
    error,
  }
}
